import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["innerHTML"]

import { IDDialogButton, useDialogPluginComponent } from "draivn-ui-kit";
import { Ref, toRefs, watch } from "vue";
import { ECommonMessages } from "../../types";
import { I18N_SERVICE_INJECTION_KEY } from "@/constants";
import { injector } from "@/services";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    title: {},
    icon: {},
    message: {},
    titleColor: {},
    iconColor: {},
    iconBgColor: {},
    okBtn: {},
    cancelBtn: {},
    isShow: {}
  },
  emits: [...useDialogPluginComponent.emits],
  setup(__props: any) {

const t = injector.injectFromRoot(I18N_SERVICE_INJECTION_KEY).global.t;



const { dialogRef, onDialogCancel, onDialogOK, onDialogHide } =
  useDialogPluginComponent();

const props = __props;
const { message, title } = toRefs(props);

if (props.isShow) {
  watch(
    props.isShow,
    (isShow: boolean) => {
      if (!isShow) {
        onDialogCancel();
      }
    },
    { immediate: true }
  );
}

const okButton = props.okBtn
  ? {
      ...props.okBtn,
      label: props.okBtn.label || t(ECommonMessages.OK),
      color: props.okBtn.color || "b400",
      handler: onDialogOK,
    }
  : undefined;

const cancelButton = props.cancelBtn
  ? {
      ...props.cancelBtn,
      label: props.cancelBtn.label || t(ECommonMessages.CANCEL),
      handler: onDialogCancel,
    }
  : undefined;

return (_ctx: any,_cache: any) => {
  const _component_d_icon = _resolveComponent("d-icon")!
  const _component_d_dialog = _resolveComponent("d-dialog")!

  return (_openBlock(), _createBlock(_component_d_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    "no-esc-dismiss": "",
    "no-backdrop-dismiss": "",
    "ok-button": _unref(okButton),
    "cancel-button": _unref(cancelButton),
    size: "sm",
    onHide: _unref(onDialogHide)
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["icon drv-mb-2", { [`drv-bg-color-${_ctx.iconBgColor}`]: !!_ctx.iconBgColor }])
        }, [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(_component_d_icon, {
                key: 0,
                name: _ctx.icon,
                color: _ctx.iconColor,
                size: 28
              }, null, 8, ["name", "color"]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("h4", {
          class: _normalizeClass(["title drv-color-n900 drv-heading-xl drv-text-weight-medium", { [`drv-color-${_ctx.titleColor}`]: !!_ctx.titleColor }])
        }, _toDisplayString(_unref(title) || _ctx.$t(_unref(ECommonMessages).CONGRATULATION_MESSAGE_TITLE)), 3),
        _createElementVNode("div", {
          class: "message drv-text-body-md drv-color-n800",
          innerHTML: _unref(message)
        }, null, 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["ok-button", "cancel-button", "onHide"]))
}
}

})